/**
 * Audit Event Emitter Service
 *
 * Fire-and-forget POST to /settings/api/v1/audit.
 * Never blocks UI — errors are silently caught.
 * JWT provides hospitalId, userId, sessionId, scopeType automatically.
 */
import type { AuditLogRequest } from '@tms-phoenix/tms-types';
import { getApiClient } from './api.service';
import { API_ROUTES } from '@/core/config';

/**
 * Emit an audit event to the backend.
 * This is intentionally fire-and-forget — the caller should NOT await this.
 * Any error (network, serialization, missing context) is silently swallowed
 * so audit instrumentation can never disrupt the application flow.
 */
export function logAuditEvent(payload: Partial<AuditLogRequest>): void {
  try {
    const api = getApiClient();
    api.post(`${API_ROUTES.SETTINGS}/audit`, payload).catch(() => {
      // Silent — audit failures must never impact the user experience
    });
  } catch {
    // Guard against getApiClient() throwing before auth is ready
  }
}
